import { mString } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import PayOnlineButton from 'components/Payments/payroc/PayOnlineButton';
import {
  usePaymentContext,
  usePaymentContextApi
} from 'components/Payments/NewPayment/PaymentContent/context/PaymentContext';

const Footer = ({ step, amount, onClose, status }) => {
  const { values } = usePaymentContext();
  const { handlePayment } = usePaymentContextApi();

  const isNewCard = step === 'credit-card';

  if (status === 'success') return null;

  return (
    <div className="flex w-full items-center justify-between gap-3">
      <Button
        text={isNewCard ? 'Back' : 'Cancel'}
        variant="tertiary"
        size="large"
        textClassName="text-lg"
        className="h-12 px-8"
        onClick={onClose}
      />
      {!isNewCard && values.methodDetail && (
        <Button
          text={`Pay ${mString(amount)}`}
          size="large"
          textClassName="text-lg"
          className="h-12 px-8"
          onClick={handlePayment}
        />
      )}

      {isNewCard && <PayOnlineButton className="justify-end" />}
    </div>
  );
};

export default Footer;
